<template>
  <div class="table-responsive bg-white rounded-3 mb-0 mt-4">
    <BTable
      id="my-table"
      :items="data"
      :fields="header"
      :per-page="perPage"
      :current-page="currentPage"
    >
      <template #cell(no)="data">
        {{ data.index + 1 }}
      </template>
      <template #cell(is_online)>
        <i class="fas fa-circle" style="color: #38c41c"></i>
      </template>
      <template #cell(room_category)="props">
        <!-- <BBadge
                    class="badge-type-room"
                    :bg-variant="getBadgeTypeRoom(getRoomCategoryName(props.item))"
                >
                    
                </BBadge> -->

        <CBadge :bg_color="getRoomCategoryColor(props.item)">
          {{ getRoomCategoryName(props.item) }}
        </CBadge>
      </template>
      <template #cell(status_room)="props">
        <!-- <BBadge
          class="badge-status-room text-capitalize"
          :bg-variant="
            getBadgeStatusRoom(props.item.status || props.item.status_room)
          "
        >
        
          <img width="16" :src="props.item.status.icon" alt="">
          {{ props.item.status || props.item.status_room }}
        </BBadge> -->
        <span
          :class="`badge badge-status text-${getBadgeStatusRoom(
            props.item.status || props.item.status_room
          )} border border-${getBadgeStatusRoom(
            props.item.status || props.item.status_room
          )}`"
        >
        {{ getLabelStatusRoom(props.item.status || props.item.status_room) }}
        </span>
      </template>

      <template #cell(status_room_available)="props">
        <span
          :class="`badge badge-status text-success border border-success`"
        >
        {{props.item.status_room_available}}
        </span>
      </template>

      <template #cell(status_maintenance)="props">
        <BBadge
          class="badge-status-maintenance"
          :bg-variant="getBadgeStatusMaintenance(props.item.status_maintenance)"
        >
          {{ props.item.status_maintenance }}
        </BBadge>
      </template>
      <template #cell(status_reservation)="props">
        <span
          :class="`badge badge-status text-${getBadgeStatusReservation(
            props.item.status || props.item.status_reservation
          )} border border-${getBadgeStatusReservation(
            props.item.status || props.item.status_reservation
          )}`"
        >
          {{ props.item.status || props.item.status_reservation }}
        </span>
      </template>

      <template #cell(status)="props">
        <span
          :class="`badge badge-status text-${getBadgeStatusMaintenance(
            props.item.status
          )} border border-${getBadgeStatusMaintenance(
            props.item.status
          )} w-100`"
        >
          {{ getLabelStatusMaintenance(props.item.status) }}
        </span>
      </template>
      <!-- <template #cell(status_reservation)="props">
                <span
                    :class="`badge badge-status text-${getBadgeStatusReservation(props.item.status_reservation.key)} border border-${getBadgeStatusReservation(props.item.status_reservation.key)}`"
                >
                    {{ props.item.status_reservation.label }}
                </span>
            </template> -->
      <template #thead-top>
        <slot name="thead-top"></slot>
      </template>
      <template #cell(action)="props">
        <div class="d-flex justify-content-center align-items-center gap-2">
          <template v-for="(action, index) in customActions" :key="index">
               <template v-if="canShowAction(action, props.item)">
              <!-- If it's a dropdown -->
              <div v-if="action.isDropdown" class="btn-group dropstart">
                <BButton
                  :variant="getButtonVariant(props.item, action)"
                  class="rounded"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-tooltip="getLabel(props.item, action)"
                  :disabled="handleDisabledAction(props.item, action)"
                >
                  <i :class="`${action.icon} text-white`"></i>
                </BButton>
                <div class="dropdown-menu">
                  <a
                    v-for="(subAction, subIndex) in action.actions"
                    :key="subIndex"
                    class="dropdown-item"
                    href="#"
                    @click.prevent="subAction.action(props.item)"
                  >
                    <i :class="`${subAction.icon} me-2`" />
                    {{ subAction.label }}
                  </a>
                </div>
              </div>
              <!-- Otherwise, regular button -->
              <BButton
                v-else
                :variant="getButtonVariant(props.item, action)"
                @click="handleAction(props.item, action)"
                v-tooltip="getLabel(props.item, action)"
                :disabled="handleDisabledAction(props.item, action)"
              >
                <i :class="`${action.icon} text-white`"></i>
              </BButton>
            </template>
          </template>
        </div>
      </template>

      <!-- for show name staff in menu tabel admin -->
      <template #cell(employee)="props">
        {{ props.item.employee?.fullname || "-" }}
      </template>

      <!-- Event Type Badge for Activity Logs -->
      <template #cell(event_type)="props">
        <BBadge
          :variant="props.item.event_type === 'created' ? 'success' : props.item.event_type === 'deleted' ? 'danger' : 'primary'"
          class="text-capitalize"
        >
          {{ props.item.event_type }}
        </BBadge>
      </template>

      <!-- pass through custom-foot for injecting footer rows -->
      <template #custom-foot="props">
        <slot name="custom-foot" v-bind="props"></slot>
      </template>
    </BTable>
  </div>
  <div
    class="pagination d-lg-flex d-flex align-items-center justify-content-between bg-white rounded-3"
  >
    <div class="d-lg-flex d-flex align-items-center p-4">
      <div class="pagination-option">
        <BFormSelect v-model="perPage" :options="options" class="">
        </BFormSelect>
      </div>
      <div class="pagination-text">
        <span class="ms-2" style="white-space: nowrap"
          >Showing {{ (currentPage - 1) * perPage + 1 }} to
          {{ Math.min(currentPage * perPage, data.length) }} of
          {{ data.length }}
        </span>
      </div>
    </div>
    <div class="w-25 p-4">
      <BPagination
        v-model="currentPage"
        :total-rows="data.length"
        :per-page="perPage"
        aria-controls="my-table"
        class="mb-0 justify-content-end"
      >
      </BPagination>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import {
  BTable,
  BPagination,
  BFormSelect,
  BButton,
  BBadge,
} from "bootstrap-vue-next";
import CBadge from "./CBadge.vue";

export default {
  name: "DataTable",
  components: {
    BTable,
    BPagination,
    BFormSelect,
    BButton,
    BBadge,
    CBadge,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    header: {
      type: Array,
      default: () => [],
    },
    rows: Number,
    customActions: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const perPage = ref(10);
    const currentPage = ref(1);
    const options = ref([
      {
        text: "10",
        value: 10,
      },
      {
        text: "25",
        value: 25,
      },
      {
        text: "50",
        value: 50,
      },
    ]);

    const getLabel = (item, action) => {
      if (typeof action.label === "function") {
        return action.label(item);
      }
      return action.label;
    };
    const getRoomCategoryName = (item) => {
      if (item?.room_category?.name) {
        return item.room_category.name;
      }
      if (item?.reservation?.room?.room_category?.name) {
        return item.reservation.room.room_category.name;
      }
      if (item?.room?.room_category?.name) {
        return item.room.room_category.name;
      }
      if (item?.room_category) {
        return item.room_category;
      }

      console.log("dtable", item);

      return "Unknown";
    };
    const getRoomCategoryColor = (item) => {
      if (item?.room_category?.color) {
        return item.room_category.color;
      }
      if (item?.reservation?.room?.room_category?.color) {
        return item.reservation.room.room_category.color;
      }
      if (item?.room?.room_category?.color) {
        return item.room.room_category.color;
      }
      if (item?.color) {
        return item.color;
      }

      return "Unknown";
    };
    const getBadgeTypeRoom = (type) => {
      switch (type) {
        case "Deluxe":
          return "danger";
        case "Super Deluxe":
          return "light";
        case "Family":
          return "orange";
        case "Studio":
          return "success";
        case "Honeymoon":
          return "primary";
        default:
          return "";
      }
    };
    const getBadgeStatusReservation = (status) => {
      switch (status) {
        case "Check In":
          return "primary";
        case "Check Out":
          return "orange";
        case "Checkout On":
          return "purple";
        case "In House":
          return "warning";
        case "Booked":
          return "success";
        case "available":
          return "secondary";
        case "Void":
          return "danger";
        default:
          return "";
      }
    };
    const getBadgeStatusRoom = (key) => {
      switch (key) {
        case "available" || "Available":
          return "success";
        case "reserved" || "Reserved":
          return "primary";
        case "checkin":
          return "primary";
        case "checkout":
          return "orange";
        case "inhouse":
          return "warning";
        case "under_maintenance":
          return "danger";
        case "in_cleaning":
          return "secondary";
        case "dirty":
          return "dark";
        default:
          return "";
      }
    };
    const getLabelStatusRoom = (key) => {
      switch (key) {
        case "available" || "Available":
          return "Available";
        case "reserved" || "Reserved":
          return "Reserved";
        case "checkin":
          return "Check In";
        case "checkout":
          return "Check Out";
        case "inhouse":
          return "In House";
        case "under_maintenance":
          return "Maintenance";
        case "in_cleaning":
          return "In Cleaning";
        case "dirty":
          return "Dirty";
        default:
          return "";
      }
    };
    const getBadgeStatusMaintenance = (key) => {
      switch (key) {
        case "under maintenance":
          return "danger";
        case "active":
          return "success";
        case "inactive":
          return "danger";
        case "non-active":
          return "danger";
        default:
          return "success";
      }
    };
    const getLabelStatusMaintenance = (key) => {
      switch (key) {
        case "under maintenance":
          return "Under Maintenance";
        case "active":
          return "Active";
        case "inactive":
          return "Inactive";
        case "non-active":
          return "Inactive";
        case "finish":
          return "Finish";
        default:
          return "-";
      }
    };

    const getButtonVariant = (item, action) => {
      if (item.start_time !== "-" && item.end_time === "-") {
        return "danger";
      }
      if (
        (action.label === "Payment" && item.status_payment === "DP") ||
        (action.label === "Check In" && item.status_payment === "DP") ||
        (action.label === "Update" &&
          item.status_maintenance === "Maintenance Completed") ||
        item.status_cleaning === "finish"
      ) {
        return "secondary";
      }
      if (typeof action.variant === "function") {
        return action.variant(item);
      }
      return action.variant;
    };
    const handleAction = (item, action) => {
      if (typeof action.action === "function") {
        action.action(item);
      } else {
        console.warn("Action tidak memiliki fungsi:", action);
      }
    };
    const handleDisabledAction = (item, action) => {
      if (typeof action.disabled === "function") {
        return action.disabled(item);
      }
      return !!action.disabled;
    };
    const canShowAction = (action, item) => {
      if (typeof action.show === 'function') {
        return action.show(item)
      }
      return action.show !== false
    };
    
    return {
      perPage,
      options,
      currentPage,
      getBadgeTypeRoom,
      getBadgeStatusReservation,
      getBadgeStatusRoom,
      getButtonVariant,
      getBadgeStatusMaintenance,
      handleAction,
      handleDisabledAction,
      getRoomCategoryName,
      getRoomCategoryColor,
      getLabelStatusMaintenance,
      getLabel,
      getLabelStatusRoom,
      canShowAction,
    };
  },
};
</script>

<style>
@media screen and (max-width: 576px) {
  .pagination-option select {
    line-height: 1.25rem;
  }
  .pagination-option option {
    font-size: 0.95rem;
  }
  .pagination-text {
    font-size: 0.85rem;
  }
  .page-item .page-link {
    font-size: 0.75rem;
  }
}
</style>
